import { render, staticRenderFns } from "./CompanyComplaintCaixa.vue?vue&type=template&id=c6fb014c&"
import script from "./CompanyComplaintCaixa.vue?vue&type=script&lang=js&"
export * from "./CompanyComplaintCaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports